import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@saas/ui';
import { AppSkeleton } from '../pages/AppSkeleton.js';
import { ForbiddenPage } from '../pages/ForbiddenPage.js';

/** 認証必須。復元中はスケルトン、未認証なら /login?next= へ */
export function RequireAuth() {
  const { status, me } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <AppSkeleton />;
  if (status === 'anonymous') return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  // 2 要素認証が必須のテナントで未登録（サーバは登録用の口以外を 403 で止めている = TWO_FACTOR_SETUP_REQUIRED）。体験のために先回りして登録画面へ
  const twoFactor = (me as { twoFactor?: { enabled: boolean; required: boolean } } | null)?.twoFactor;
  if (twoFactor?.required && !twoFactor.enabled && !loc.pathname.startsWith('/settings/security')) return <Navigate to="/settings/security" replace />;
  const externalGuest = me?.roles.includes('guest') && !me.roles.some((r) => r !== 'guest');
  const guestAllowed = loc.pathname.startsWith('/chat') || loc.pathname.startsWith('/settings/profile') || loc.pathname.startsWith('/settings/security') || loc.pathname.startsWith('/settings/notifications');
  if (externalGuest && !guestAllowed) return <Navigate to="/chat" replace />;
  return <Outlet />;
}

/** ログイン・サインアップ。ログイン済みなら next（無ければ /）へ */
export function PublicOnly() {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <AppSkeleton />;
  if (status === 'authenticated') {
    const next = new URLSearchParams(loc.search).get('next');
    return <Navigate to={next && next.startsWith('/') ? next : '/'} replace />;
  }
  return <Outlet />;
}

/** 機能フラグ（me.enabledModules）。無効なモジュールのルートは 403 の画面 */
export function ModuleGate({ module }: { module: string }) {
  const { isModuleEnabled } = useAuth();
  if (!isModuleEnabled(module)) return <ForbiddenPage reason="module" />;
  return <Outlet />;
}
